import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnumExportStatus } from 'src/app/models/report.model';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'que-mlm-export-status-filter',
  imports: [CommonModule, TranslateDirective, TranslatePipe],
  templateUrl: './mlm-export-status-filter.component.html',
  styleUrls: ['./mlm-export-status-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: MlmExportStatusFilterComponent, multi: true }]
})
export class MlmExportStatusFilterComponent implements OnInit {
  enumExportStatus = EnumExportStatus;
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  selectedFilter$ = toSignal(this.#manipulationsToolbarStore.selectedFilter$);
  statusList = [
    {
      status: EnumExportStatus.Exported,
      choosed: false
    },
    {
      status: EnumExportStatus.Failed,
      choosed: false
    },
    {
      status: EnumExportStatus.NotExported,
      choosed: false
    },
  ];

  ngOnInit() {
    this.statusList.map(x => this.selectedFilter$()?.mlmExportStatus?.includes(x.status) ? x.choosed = true : false)
  }

  valueControl = new FormControl<EnumExportStatus[] | null>(null);
  callBackFunction: Function = () => { };

  writeValue(obj: any): void {
    this.valueControl.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.callBackFunction = fn;
  }

  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }

  selectStatus(item: any) {
    item.choosed = !item.choosed;
    const itemsSelected = this.statusList.filter(x => x.choosed == true).map(x => { return x.status });
    this.valueControl.setValue(itemsSelected);
    if (this.callBackFunction) {
      this.callBackFunction(this.valueControl.value);
    }
  }
}
